import React from 'react'
import { useTranslation } from 'react-i18next'

import ThermalPrint, { ThermalPrintButton, useThermalPrint } from 'pages/parts/ThermalPrint'

import { formatMoney, formatDate } from 'helpers/helpers'

function Index({ showRightBar, setShowRightBar, data }) {
	const { t } = useTranslation()
	const { printRef, handlePrint } = useThermalPrint()

	// Снятые строки (status -1) — старая редакция после правки прихода, показывать их не нужно
	const items = (data?.items || []).filter(item => Number(item.status) !== -1)

	return (
		<>
			<div className="right-sidebar-background" onClick={() => setShowRightBar(!showRightBar)}></div>
			<div className="right-sidebar p-2">
				<div className="position-relative">
					<div className="px-2"
						style={{
							position: 'absolute',
							top: '0',
							right: '0',
							zIndex: 2,
						}}>
						<ThermalPrintButton onClick={handlePrint} />
					</div>

					<h4 className="fw-600 pe-5">{t('document_from')} {formatDate(data.created_at, 'dd.MM.yy HH:mm')}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex gap-2">
							<div className="fw-600">{t('pos')}:</div>
							<div>{data.pos_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('wms')}:</div>
							<div>{data.wms_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('supplier')}:</div>
							<div>{data.supplier_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '40%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('unit')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{items.map((item, index) => (
									<tr key={index}>
										<td className="text-center" title={item.id}>
											{index + 1}
										</td>
										<td title={item.element_id}>{item.element_name}</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td>{item.unit_name}</td>
										<td className="text-end">{formatMoney(item.price)}</td>
										<td className="text-end">{formatMoney(item.price * item.quantity)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall?.overall_quantity)}</b>
									</td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall?.overall_amount)}</b>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<ThermalPrint
				printRef={printRef}
				title={`${t('document_from')} ${formatDate(data.created_at, 'dd.MM.yy HH:mm')}`}
				info={[
					{ label: t('pos'), value: data.pos_name },
					{ label: t('wms'), value: data.wms_name },
					{ label: t('supplier'), value: data.supplier_name },
					{ label: t('note'), value: data.note },
				]}
				columns={[
					{ label: t('name2'), width: '42%', numbered: true, render: (item) => item.element_name },
					{ label: t('quantity'), width: '16%', align: 'end', render: (item) => formatMoney(item.quantity, 2) },
					{ label: t('price'), width: '20%', align: 'end', render: (item) => formatMoney(item.price) },
					{ label: t('amount'), width: '22%', align: 'end', render: (item) => formatMoney(item.price * item.quantity) },
				]}
				rows={items}
				total={[t('total'), formatMoney(data?.overall?.overall_quantity), '', formatMoney(data?.overall?.overall_amount)]}
			/>
		</>
	)
}

export default Index
